/**
 * 本地存储缓存
 * 存取时自动 parse 和 stringify JSON
 */
export class JsonStorageCache {
    constructor(storage) {
        this.storage = storage;
    }
    set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
    }
    get(key) {
        const value = this.storage.getItem(key);
        try {
            return value ? JSON.parse(value) : null;
        }
        catch (e) {
            console.error(`Failed to parse JSON from storage for key: ${key}`, e);
            return null;
        }
    }
    remove(key) {
        this.storage.removeItem(key);
    }
}
